import { SetupAssistantConfig } from '@kizenapps/engine';

export interface MarketplacePlugin {
  api_name: string;
  config_template: Record<string, any>;
  created: string;
  description?: string;
  external_link?: string;
  github_repo?: string;
  is_open_source?: boolean;
  id: string;
  managed_by_business: {
    id: string;
    name: string;
    reply_to_email: string;
  };
  name: string;
  published: true;
  thumbnail?: string;
  updated?: string;
  base_config?: {
    secrets?: Array<string>;
    user_configurable?: boolean;
    setup_assistant?: SetupAssistantConfig;
    user_setup_assistant?: SetupAssistantConfig;
    forceEnable?: boolean;
    disableDetailView?: boolean;
    editConfigurationOverride?: string;
    kzn_schema_file?: string;
    kzn_schema_etag?: string;
    disabled_keys?: Array<string>;
  };
  services?: Array<{
    auth_level: string;
    auth_type: string;
    base_service_url: string;
    display_name: string;
    required_entitlement?: string | null;
    service_name: string;
  }>;
}

export enum MarketPlacePluginApiName {
  KizenAI = 'kizen_ai',
}
